// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

//for PWA features
import './registerServiceWorker' 

// Fonts and icons should be loaded before Vuetify to ensure they are available for use in the theme and components
import '@/assets/fonts/material-icons.css'
import '@/assets/fonts/fontawesome.css'

// Vuetify should load after base fonts
import './plugins/vuetify'

// Axios configuration should be loaded before any component that uses it
import './common/axios_config'

import App from './App'
import router from './router'
import store from './store'
import responsive from '@/mixins/responsive'

// Custom global styles should be loaded after all libraries to ensure they can override defaults as needed
import '@/assets/css/main.css'

Vue.config.productionTip = false

Vue.mixin(responsive)
Vue.use(require('vue-moment'))

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

